import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

export const addClass = async ({
  userId,
  classIds,
}: {
  userId: string
  classIds: number[]
}) => {
  return axiosInstance.post('/class/add-user-class', {
    user_id: userId,
    class_ids: classIds,
  })
}

export const useAddClass = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: addClass,
    mutationKey: ['add_class'],
  })

  return {
    addClassAsync: mutateAsync,
    isAddingClass: isPending,
  }
}
